import type { FC } from 'react';
import { useStore } from 'zustand';

import { ModalListErrors } from 'Features/SellerCommunications/components/ModalListErrors';
import { MarkAsContactedStore } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';

export const MarkAsContactedError: FC = () => {
	const { errorGroups, result } = useStore(MarkAsContactedStore);

	const updatedSalesCount = result.updatedSales.length;
	const failedToUpdateSalesCount = result.failedToUpdateSales.length;

	const errorsText = T.translate(
		`markAsContacted.error.description.${failedToUpdateSalesCount === 1 ? 'error_singular' : 'error_plural'}`,
		{ errorsCount: failedToUpdateSalesCount },
	);
	const successText = T.translate(
		`markAsContacted.error.description.${updatedSalesCount === 1 ? 'success_singular' : 'success_plural'}`,
		{ successCount: updatedSalesCount },
	);

	return (
		<ModalListErrors
			groups={errorGroups}
			headerDescription={`${successText}${errorsText}`}
			headerTitle={T.translate(`markAsContacted.error.title`)}
			infoBoxDescription={T.translate('markAsContacted.error.infoBox.description')}
			infoBoxTitle={T.translate(
				`markAsContacted.error.infoBox.title.${failedToUpdateSalesCount === 1 ? 'single' : 'multiple'}`,
				{
					count: failedToUpdateSalesCount,
				},
			)}
		/>
	);
};
